var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrops = function SvgDrops(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 135,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#drops_svg__a)",
    d: "M93.5 88c-7.028 0-13.769-2.83-18.738-7.867C69.792 75.096 67 68.264 67 61.141c0-11.032 5.035-19.301 11.17-29.376C82.94 23.928 88.376 15 92.627 2.828c.248-.711.868-2.828.868-2.828l.004.013.004-.013s.62 2.117.868 2.828c4.25 12.172 9.687 21.1 14.459 28.937C114.965 41.84 120 50.109 120 61.14c0 7.123-2.792 13.955-7.762 18.992C107.304 85.135 100.479 88 93.5 88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#drops_svg__b)",
    d: "M10.259 134.669a10.25 10.25 0 0 1-7.254-3.01A10.29 10.29 0 0 1 0 124.393c0-4.221 1.95-7.385 4.324-11.24 1.847-2.998 3.951-6.414 5.597-11.071.096-.272.336-1.082.336-1.082l.002.005.001-.005s.24.81.336 1.082c1.646 4.657 3.75 8.073 5.597 11.071 2.375 3.855 4.324 7.019 4.324 11.24 0 2.725-1.08 5.339-3.005 7.266a10.32 10.32 0 0 1-7.254 3.01"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "drops_svg__a",
    x1: 93.5,
    x2: 93.5,
    y1: -104.378,
    y2: 162.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#9FCFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#99AEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#A293FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#C389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#E98EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F992D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#FFE0A3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "drops_svg__b",
    x1: 10.258,
    x2: 10.258,
    y1: 25.529,
    y2: 290.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1E3EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#9FCFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#99AEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#A293FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#C389F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#E98EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F992D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#FFE0A3"
  })))));
};
export default SvgDrops;